/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { get, isEmpty, orderBy, reverse, sortBy } from 'lodash-es';
import { ActionStatus } from '../../constants/api';
import { ActionType } from '../../constants/redux';
import { CLEAR_CREATE_RECORD, CREATE_RECORD, RecordState } from './types';


const INITIAL_STATE: RecordState = {
	CREATE_RECORD_STATUS: ActionStatus.NONE,
	createError:{}
	
};

const RecordReducer = (state: RecordState = INITIAL_STATE, action: ActionType): RecordState => {
	switch (action.type) {
		
		case CREATE_RECORD.name: {
			return { ...state, CREATE_RECORD_STATUS: ActionStatus.LOADING, createError: {} };
		}
		case CREATE_RECORD.success: {
			return {
				...state,
				CREATE_RECORD_STATUS: ActionStatus.SUCCESS
			};
		}
		case CLEAR_CREATE_RECORD.name: {
			return {
				...state,
				CREATE_RECORD_STATUS: ActionStatus.LOADING,
				
			};
		}
		case CREATE_RECORD.failure: {
			const status = get(action.payload, 'status', 0);
			const p = get(action.payload, 'response', {});

			const response =
				status === 500 && isEmpty(p)
					? { display_message: 'Server error', action_message: 'Please try again later.' }
					: p;

			return {
				...state,
				CREATE_RECORD_STATUS: ActionStatus.FAILURE,
				createError: { ...response, status }
			};
		}
		

		default:
			return state;
	}
};

export default RecordReducer;
